import { InjectionToken } from '@angular/core';

export const SITE_NAME = new InjectionToken<string>('SiteName');
